import { render, staticRenderFns } from "./basic_info.vue?vue&type=template&id=2abaf1c4"
import script from "./basic_info.vue?vue&type=script&lang=js"
export * from "./basic_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2abaf1c4')) {
      api.createRecord('2abaf1c4', component.options)
    } else {
      api.reload('2abaf1c4', component.options)
    }
    module.hot.accept("./basic_info.vue?vue&type=template&id=2abaf1c4", function () {
      api.rerender('2abaf1c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/weekday_adjust_details/components/basic_info.vue"
export default component.exports